import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const TrackEvent = gql`
  mutation TrackEvent($input: TrackEventInput!) {
    trackEvent(input: $input) {
      __typename
      ... on TrackEventSuccess {
        event
      }
      ... on TrackEventError {
        ...error
      }
    }
  }
  ${error}
`;

export default TrackEvent;
